import React from 'react';
import { FloatingLabelInput } from '../FloatingLabelInput';
import { inputToFormattedDateOfBirth } from './utils';
import { dobValidation } from './validation';

var DateOfBirth = props => {
  var getDateChangeHandler = (datePattern, changeHandler) => {
    return (e, value, oldValue, meta) => {
      var {
        newValue,
        formattedDate
      } = inputToFormattedDateOfBirth(value, datePattern);
      meta.validation = dobValidation(formattedDate);
      changeHandler(e, newValue, oldValue, meta);
    };
  };

  return React.createElement(FloatingLabelInput, {
    blurHandler: props.blurHandler,
    changeHandler: getDateChangeHandler(props.datePattern, props.changeHandler),
    containerStyleOverrides: props.containerStyleOverrides,
    displayError: props.displayError,
    error: props.error,
    focusHandler: props.focusHandler,
    id: props.id,
    label: props.label,
    placeholder: props.dateFormat,
    required: props.required,
    type: "tel",
    value: props.value
  });
};

export { DateOfBirth };